import React, { useState, useCallback } from 'react';
import './LogicApps.css';
import AppCard from './AppCard';
import { LOGIC_APPS } from '../logicAppsConfig';

const TIME_RANGES = [
  { key: 'day',   label: 'Last 24 hours' },
  { key: 'week',  label: 'Last 7 days'   },
  { key: 'month', label: 'Last 30 days'  },
];

function LogicApps({ apiCall }) {
  const [timeRange, setTimeRange]   = useState('day');
  const [search, setSearch]         = useState('');
  const [appStats, setAppStats]     = useState({});
  const [selectedApp, setSelectedApp] = useState(null);

  const handleDataLoaded = useCallback((id, stats) => {
    setAppStats(prev => ({ ...prev, [id]: stats }));
  }, []);

  const term = search.trim().toLowerCase();

  const visibleApps = LOGIC_APPS
    .filter(app =>
      !term ||
      app.displayName.toLowerCase().includes(term) ||
      app.workflowName.toLowerCase().includes(term)
    )
    .sort((a, b) => {
      const aStats = appStats[a.id];
      const bStats = appStats[b.id];
      const aCompleted = aStats ? aStats.succeeded + aStats.failed : 0;
      const bCompleted = bStats ? bStats.succeeded + bStats.failed : 0;
      const aRate = aCompleted > 0 ? aStats.succeeded / aCompleted : null;
      const bRate = bCompleted > 0 ? bStats.succeeded / bCompleted : null;
      // Not yet loaded goes to end
      if (aRate === null && bRate === null) return a.displayName.localeCompare(b.displayName);
      if (aRate === null) return 1;
      if (bRate === null) return -1;
      // Worst success rate first
      if (aRate !== bRate) return aRate - bRate;
      return a.displayName.localeCompare(b.displayName);
    });

  return (
    <div className="logicapps">
      {/* Controls */}
      <div className="logicapps-controls">
        <div className="time-range-tabs">
          {TIME_RANGES.map((r) => (
            <button
              key={r.key}
              className={`time-tab ${timeRange === r.key ? 'active' : ''}`}
              onClick={() => setTimeRange(r.key)}
            >
              {r.label}
            </button>
          ))}
        </div>

        <input
          className="logicapps-search"
          type="search"
          placeholder="Search workflows…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {/* App grid */}
      {visibleApps.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">&#9881;</div>
          {LOGIC_APPS.length === 0 ? (
            <>
              <h3>No Logic Apps configured</h3>
              <p>Add your Logic Apps to <code>src/logicAppsConfig.js</code> to start monitoring.</p>
            </>
          ) : (
            <>
              <h3>No results</h3>
              <p>Try a different search term.</p>
            </>
          )}
        </div>
      ) : (
        <div className="apps-grid">
          {visibleApps.map((app) => (
            <AppCard
              key={app.id}
              app={app}
              timeRange={timeRange}
              apiCall={apiCall}
              onDataLoaded={handleDataLoaded}
              onViewDetails={(app, failedRuns) => setSelectedApp({ app, failedRuns })}
            />
          ))}
        </div>
      )}

      {selectedApp && (
        <RunDetailsLazy
          app={selectedApp.app}
          failedRuns={selectedApp.failedRuns}
          apiCall={apiCall}
          onClose={() => setSelectedApp(null)}
        />
      )}
    </div>
  );
}

function RunDetailsLazy(props) {
  const RunDetails = require('./RunDetails').default;
  return <RunDetails {...props} />;
}

export default LogicApps;
